import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { MiscellanyOrderService } from "../../../service/miscellany/MiscellanyOrderService";

class MiscellanyOrderDescriptionStore {

    public deliveryOrderId?: string;
    public deliveryOrderDescription: string;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore, description: string, deliveryOrderId?: string) {
        this.deliveryOrderId = deliveryOrderId;
        this.isModalOpen = false;
        this.deliveryOrderDescription = description;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async updateDescription() {
        this.loading = true;
        const response = await MiscellanyOrderService.updateDescription(this.deliveryOrderId!, this.deliveryOrderDescription);
        if (response.success && response.data) {
            // TODO: Revisar porque cuando llamo el showSuccessToast se queda la lista de envios vacia.
            // this.commonStore.showSuccessToast('Observaciones actualizadas satisfactoriamente!!!')
            this.closeModal();
            return true;
        }
        this.loading = false;
        return false;
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }
}

export default MiscellanyOrderDescriptionStore;